<template>
  <div class="core-indicators-wrap">
    <v-title :title="title" :tip-txt='tipTxt' mg-btm="mg-btm15" />
    <ul class="f-df f-ai f-fww">
      <li
        v-for="(item, index) in list"
        :key="index"
        class="f-df f-aifs mg-column30 cor-item f-jc">
        <!-- <i :class="item.icon" class="iconfont item-icon"></i> -->
        <figure class="figure-icon">
          <img :src="item.imgIcon" width="100%">
        </figure>
        <div class="mg-left20 right-box">
          <h5 class="f-fwn color-light-gray">{{ item.name }}</h5>
          <p class="f-fs28 mg-top5">{{ item.sum }}</p>
          <span class="f-fs1 mg-top5 f-df f-ai">
            <i class="mg-right5 color-lighter-gray">与上期比</i>
            <em :class="(item.rate && item.rate.indexOf('-') >= 0) ? 'color-green' : 'color-red'" class="f-fwn">
            {{ !item.rate ? '-' : (item.rate.indexOf('-') >= 0 ? '' : '+') + item.rate }}</em>
          </span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import vTitle from '@/components/vTitle.vue'
export default {
  components: {
    vTitle
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    tipTxt: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      imgIcon: ''
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.core-indicators-wrap{
  & ul {
    & li {
      width: 25%;
      border-right: 1px solid #ddd;
      &:first-child,
      &:nth-child(4n + 1){
        justify-content: flex-start;
        padding-left: 60px;
      }
      &:nth-child(4n), &:last-child{
        border-right: 0;
      }
      & .figure-icon{
        width: 50px;
        height: 50px;
      }
      & .item-icon{
        font-size: 48px;
      }
      & .right-box{
        min-width: 140px;
      }
    }
  }
}
</style>
